/* eslint-disable react/display-name */
import React from "react";

const Button = React.forwardRef(({ active, reversed, ...props }, ref) => (
  <div
    {...props}
    ref={ref}
    css={{
      cursor: "pointer",
      color: `${reversed ? (active ? "white" : "#aaa") : active ? "black" : "#ccc"}`,
    }}
  />
));

export default Button;
